<template>
  <v-navigation-drawer
    class="customer-card"
    v-model="card"
    width="320"
    stateless
    absolute
    hide-overlay
  >
    <v-list-item style="min-height: auto">
      <v-list-item-content>
        <v-list-item-title
          class="pr-5 company-button"
          style="font-size: 14px; font-weight: 700; cursor: pointer"
          @click="$emit('show-company-info-dialog', selectedCustomer)"
          >{{ selectedCustomer.name }}</v-list-item-title
        >
      </v-list-item-content>
    </v-list-item>

    <v-list-item style="min-height: auto">
      <v-row>
        <v-col
          cols="6"
          v-for="(header, i) in filteredHeaders"
          :key="i"
          class="d-flex flex-column"
        >
          <p
            style="text-transform: uppercase;
    color: #9c9c9c; font-size: 10px;"
            class="mb-0"
          >
            {{ header.text }}
          </p>
          <p
            style="font-weight: 700;
    color: #1a1a1a; font-size: 12px"
            class="mb-0 mt-auto"
          >
            {{ selectedCustomer[header.value] }}
          </p>
        </v-col>
      </v-row>
    </v-list-item>

    <v-list-item style="min-height: auto">
      <p
        style="font-size: 12px; line-height: 1.2; color: #9c9c9c"
        v-html="selectedCustomer.description"
      ></p>
    </v-list-item>
    <v-spacer></v-spacer>
    <v-list-item style="min-height: auto">
      <v-row>
        <v-col>
          <p
            style="text-transform: uppercase;
    color: #9c9c9c; font-size: 10px;"
            class="mb-0"
          >
            {{ mess["customer_card_equipment_list_title"] }}
          </p>
        </v-col>
      </v-row>
    </v-list-item>
    <v-list-item style="min-height: auto">
      <v-row>
        <v-col>
          <div class="b-vendor__equipment-scroll">
            <ul
              v-if="equipment && equipment.length"
              class="b-vendor__equipment"
            >
              <li v-for="(item, i) in equipment" :key="i">
                <a
                  :href="
                    '/personal/my_customers/installed_bases/redirectToCataogByCrmId.php?equimpent_crm_id=' +
                      item.id
                  "
                  target="_blank"
                  style="text-decoration: none"
                  >{{ item.brand }} {{ item.model }}</a
                >
              </li>
            </ul>
            <ul v-else class="b-vendor__equipment">
              <li>
                {{ mess["customer_card_equipment_list_empty"] }}
              </li>
            </ul>
          </div>
        </v-col>
      </v-row>
    </v-list-item>
    <v-list-item style="min-height: auto">
      <v-row class="justify-end">
        <v-col cols="auto">
          <v-btn
            @click="$emit('open-create-lead-dialog', selectedCustomer)"
            small
            depressed
            outlined
            color="primary"
            >{{ mess["dialog_create_lead_open_button"] }}</v-btn
          >
        </v-col>
      </v-row>
    </v-list-item>
    <v-btn
      absolute
      top
      right
      text
      icon
      @click="card = false"
      style="top: 15px; right: 0"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "CustomerCard",
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    headers: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    card: false
  }),
  computed: {
    filteredHeaders() {
      if (!this.headers) return [];
      return this.headers.filter(
        header => header.value !== "create_deal" && header.value !== "name"
      );
    },
    selectedCustomer() {
      return this.$store.getters.selectedCustomer;
    },
    equipment() {
      return this.selectedCustomer.items;
    },
    image() {
      return this.imgError ? this.noImageSrc : this.selectedCustomer.logo;
    }
  },
  watch: {
    isVisible(val) {
      this.card = val;
    },
    card(val) {
      this.$emit("input", val);
    }
  },
  methods: {}
};
</script>

<style lang="scss">
.customer-card {
  border: 1px solid #c9c9c9;

  .v-navigation-drawer__content {
    display: flex;
    flex-direction: column;
  }
}

.b-vendor__equipment-scroll {
  width: 100%;
  position: relative;
  height: 100%;
}

.b-vendor__equipment {
  overflow-y: scroll;
  height: 180px;
  margin-bottom: 0;
  width: 100%;
  list-style: none;

  li {
    position: relative;
    padding: 4px 0;
    margin-bottom: 0;
    font-size: 12px;

    a {
      color: #1a1a1a;
      font-size: 13px;
      font-weight: 500;
    }

    a:hover {
      color: var(--v-primary-base);
    }
  }

  li::before {
    position: absolute;
    content: "" !important;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: var(--v-primary-base);
    top: 10px;
    left: -18px;
  }

  li:not(:last-of-type)::after {
    position: absolute;
    content: "";
    width: 1px;
    height: 100%;
    left: -15px;
    top: 10px;
    background-color: var(--v-primary-base);
  }
}
</style>
